import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeginACollaboration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="begin-a-collaboration" className="dark bg-background text-foreground relative flex min-h-[600px] w-full items-center justify-center overflow-hidden py-24 px-4 md:px-8">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556059/img/darkroom_grain_texture.png)] bg-cover bg-center opacity-15 mix-blend-overlay" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(40,20,10,0.2)_0%,rgba(0,0,0,0.8)_100%)]" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-10 mx-auto w-full max-w-5xl border border-white/15 bg-black/20 backdrop-blur-[2px] transition-all duration-1000 ease-out", isVisible ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-8")}>
        {}
        <div className="absolute -top-3 left-0 w-full flex justify-center overflow-hidden">
          <div className="bg-background px-6 text-[10px] font-mono font-bold tracking-[0.3em] text-white/30 uppercase">
            Kodak Safety Film <span className="mx-4">5063</span> 35mm
          </div>
        </div>

        {}
        <div className="absolute -top-[1px] -left-[1px] h-4 w-4 border-t border-l border-white/40" />
        <div className="absolute -top-[1px] -right-[1px] h-4 w-4 border-t border-r border-white/40" />
        <div className="absolute -bottom-[1px] -left-[1px] h-4 w-4 border-b border-l border-white/40" />
        <div className="absolute -bottom-[1px] -right-[1px] h-4 w-4 border-b border-r border-white/40" />

        {}
        <div className="flex flex-col items-center justify-center py-20 px-6 text-center md:py-32">
          <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl font-medium tracking-tight text-foreground mb-12 drop-shadow-2xl">
            Capture the Timeless
          </h2>

          <div className="flex flex-col w-full max-w-md gap-6 sm:flex-row sm:w-auto sm:gap-8">
            {}
            <Button asChild size="lg" className="h-14 w-full sm:w-auto min-w-[200px] rounded-none bg-primary text-primary-foreground hover:bg-primary/90 text-base font-medium tracking-wide uppercase shadow-lg transition-transform hover:scale-[1.02]">
              <Link to="/InquirePage">
                Commission a Shoot
              </Link>
            </Button>

            {}
            <Button asChild variant="outline" size="lg" className="h-14 w-full sm:w-auto min-w-[200px] rounded-none border-foreground/40 bg-transparent text-foreground hover:bg-foreground/10 hover:text-foreground hover:border-foreground text-base font-medium tracking-wide uppercase backdrop-blur-sm transition-transform hover:scale-[1.02]">
              <Link to="/InquirePage">
                Acquire a Print
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="absolute -bottom-3 right-8 bg-background px-2 text-[9px] font-mono tracking-widest text-white/20 uppercase">
          EXP: 24 • ISO 400
        </div>
      </div>
    </section>;
}